module.exports = __webpack_public_path__ + "static/media/programmer.67a17498.svg";